import { React } from "react";
import styled from "styled-components";
import { Button, PageHeader } from "antd";
import { PaperHeaderButtonStyle } from "../../pageStyled";
import { HaberForm, BackButtonHeader } from "../../../Pages/styledElements";
import SearchIcon from "../../../Assets/Icons/search.svg";
import { useLocation, useNavigate } from "react-router";

const ReviewOrderHeader = styled.div`
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
  }
  .searchWidth {
    width: 38%;
    .ant-row {
      margin: 0;
    }
    .ant-col {
      input[type="text"] {
        padding-left: 15px !important;
      }
    }
    .searchIcon {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
        right: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${SearchIcon});
      }
    }
  }
  .exportDataBtn {
    align-self: center;
    button {
      &:last-child {
        margin-right: 0px;
      }
      svg {
        top: 3px;
      }
    }
  }
  .themeBtn {
    margin: 0px 6px !important;
  }
  .ant-page-header-heading-title {
    color: #ea655b;
    font-family: var(--sf-pro-display-m);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  svg {
    color: #ea655b;
  }
`;

  const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);


const ReviewSelectedHeader = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeBack = () => {
    props.routeBack();
  };
  return (
    <ReviewOrderHeader>
      <div className="searchBoxWrap">
        <HaberForm className="searchWidth">
          <BackButtonHeader>
            <PageHeader
              ghost={false}
              onBack={routeBack}
              title={
                <PaperHeaderButtonStyle>
                  <Button
                    key="1"
                    className="textTypeBtn"
                    style={{ margin: "0px", padding: "5px 12px" }}
                    onClick={routeBack}
                  >
                    Go back to previous page
                  </Button>
                </PaperHeaderButtonStyle>
              }
              extra={[]}
            ></PageHeader>
          </BackButtonHeader>
        </HaberForm>
        <div className="exportDataBtn">
          <Button key="1" className="textTypeBtn textBtnIcon">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ marginRight: "30px" }}>
                Total Orders : {props.totalOrders}
              </div>
              <div style={{ marginRight: "30px" }}>
                Selected Orders :{" "}
                {props.selectedOrders ? props.selectedOrders : 0}
              </div>
              <div>
                Selected Quantity :{" "}
                {props.selectedQuantity && props.weightUnit ? props.selectedQuantity + ' ' + capitalize(props.weightUnit) : 0}
              </div>
            </div>
          </Button>
        </div>
      </div>
    </ReviewOrderHeader>
  );
};
export default ReviewSelectedHeader;
